import YubiKeysReg from "./YubiKeysReg";
export default YubiKeysReg;
